<template>
	<div
		class="p-4 rounded animate-pulse md:p-6"
		:class="containerClasses"
	>
		<!-- Scaled Icon Container -->
		<div
			class="flex items-center justify-center bg-gray-300 rounded"
			:class="iconContainerClasses"
		>
			<svg
				viewBox="0 0 16 20"
				fill="currentColor"
				xmlns="http://www.w3.org/2000/svg"
				aria-hidden="true"
				class="text-(--primary-brown)"
				:class="iconClasses"
			>
				<path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
				<path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
			</svg>
		</div>

		<!-- Scaled Text Blocks -->
		<div
			v-if="props.showLoadingText"
			class="mt-4 space-y-2"
		>
			<div
				class="bg-(--primary-brown) rounded-full"
				:class="textBlockClasses[0]"
			/>
			<div
				class="bg-(--primary-brown) rounded-full"
				:class="textBlockClasses[1]"
			/>
			<div
				class="bg-(--primary-brown) rounded-full"
				:class="textBlockClasses[2]"
			/>
			<div
				class="bg-(--primary-brown) rounded-full"
				:class="textBlockClasses[3]"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
	import type {
		LoadingProps
	} from "~/types/typeDefinitions";

	const props = defineProps<LoadingProps>();

	const containerClasses = computed( () => ( {
		[`w-${ props.width ? props.width : "auto" }!`]: true,
		[`h-${ props.height ? props.height : "auto" }!`]: true,
		[props.showBorders ? "border border-(--primary-brown) shadow" : ""]: true
	} ) );

	const iconContainerClasses = computed( () => ( {
		[props.showLoadingText ? "h-2/5" : "h-full"]: true,
		"w-full": true
	} ) );

	const iconClasses = computed( () => ( {
		"w-1/4": true,
		"h-1/4": true
	} ) );

	const textBlockClasses = computed( () => [
		{ "h-2.5 w-4/5": true },
		{ "h-2 w-11/12": true },
		{ "h-2 w-3/4": true },
		{ "h-2 w-3/5": true }
	] );
</script>

<style scoped>

</style>